export const VerticalType = {
  event: 'event',
  product: 'product',
  booking: 'booking',
} as const;

export const VERTICAL_PATHS = {
  product: 'products',
  event: 'events',
  booking: 'bookings',
} as const;

export type VerticalType = keyof typeof VerticalType;
